import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Route, Switch, withRouter } from 'react-router';
import CompareExperimentsRedirect from '@experiment-details/components/ExperimentDetails/CompareExperimentsRedirect';
import SingleExperimentDetailsRoute from '@experiment-details/components/ExperimentDetails/ExperimentDetailsRoutes/SingleExperimentDetailsRoute';
import ComparisonExperimentDetailRoute from '@experiment-details/components/ExperimentDetails/ExperimentDetailsRoutes/ComparisonExperimentDetailRoute';
import ProjectTypePageSelector from '@shared/components/ProjectTypePageSelector';
import EMProjectPageHeader from '@shared/components/EMProjectPageHeader';
import ProjectPageWrapper from '@shared/components/ProjectPageWrapper';
import LLMProjectPageHeader from '@shared/components/LLMProjectPageHeader';
import { LLM_TAB_PATHNAME } from '@experiment-management-shared/constants/llmConstants';
import LLMDashboardPage from '@projects/components/LLMDashboardPage/LLMDashboardPage';
import EMDashboardPage from '@projects/components/EMDashboardPage/EMDashboardPage';
import NotesPage from '@projects/components/NotesPage';

const DashboardRoutes = ({ match }) => {
  const EMDashboardPageComponent = useMemo(() => <EMDashboardPage />, []);
  const LLMDashboardPageComponent = useMemo(
    () => (
      <ProjectPageWrapper
        header={<LLMProjectPageHeader />}
        content={<LLMDashboardPage />}
      />
    ),
    []
  );
  return (
    <Switch>
      {/* This route is using to redirect from old structure of url to new one */}
      <Route
        path={[
          `${match.path}/:baseExperimentKey/:compareExperimentKey/compare`,
          `${match.path}/archive/:baseExperimentKey/:compareExperimentKey/compare`
        ]}
        exact
        component={CompareExperimentsRedirect}
      />
      <Route
        path={[`${match.path}/compare`, `${match.path}/archive/compare`]}
        exact
        render={() => <ComparisonExperimentDetailRoute />}
      />
      <Route
        path={`${match.path}/notes`}
        exact
        render={() => (
          <ProjectTypePageSelector
            EMComponent={
              <ProjectPageWrapper
                header={<EMProjectPageHeader />}
                content={<NotesPage />}
              />
            }
          />
        )}
      />
      <Route
        path={[
          match.path,
          `${match.path}/view/:viewId?`,
          `${match.path}/archive`,
          `${match.path}/experiments`,
          `${match.path}/panels`,
          `${match.path}/view/:viewId/:section`,
          `${match.path}/${LLM_TAB_PATHNAME.prompts}`
        ]}
        exact
        render={() => (
          <ProjectTypePageSelector
            EMComponent={EMDashboardPageComponent}
            LLMComponent={LLMDashboardPageComponent}
          />
        )}
      />

      <Route
        path={[
          `${match.path}/archive/:experimentKey`,
          `${match.path}/:experimentKey`
        ]}
        render={() => <SingleExperimentDetailsRoute />}
      />
    </Switch>
  );
};

DashboardRoutes.propTypes = {
  match: PropTypes.object.isRequired
};

export default withRouter(DashboardRoutes);
